module.exports = __webpack_public_path__ + "static/media/Ionicons.13edee5c.ttf";